import { readCookie } from "./cookie.js";
import type { LogLevels } from "./level.js";

export type StatusText = "activated" | "deactivated";

export interface StatusObject {
  activated: boolean;
  pattern: RegExp | undefined;
  level: LogLevels;
  text: StatusText;
}

let statusObject: StatusObject | undefined;

export function updateStatus(
  pattern: RegExp | undefined,
  level: LogLevels = "error",
): StatusObject {
  statusObject = {
    pattern,
    activated: !!pattern,
    level,
    text: pattern ? "activated" : "deactivated",
  };
  return statusObject;
}

/**
 *
 *
 *
 *
 */
export function status(): StatusObject {
  return statusObject || updateStatus(...readCookie());
}
